import React from 'react';
import { Outlet } from 'react-router-dom';
import './App.css';
import { Container, Row, Col } from 'react-bootstrap';
import Header from './Components/Header';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '97vh' }}>
      <Header />
      <main style={{ flex: 1 }}>
        <Container fluid className="main-container">
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Outlet/>
            </Col>
          </Row>
        </Container>
      </main>
      <footer style={{ marginTop: '20px' }}>
        <Footer/>
      </footer>
    </div>
  );
}

export default App;
